<template>
  <div class="animated fadeIn mb-3">
        <b-row >
      <b-col md="3" class="tabtext">
        <span ><b>Zip Code</b></span>
      </b-col>
      <b-col md="2" class="tabtext">
        <span ><b>Quantity</b></span>
      </b-col>
      <b-col md="2" class="tabtext">
        <span ><b>City</b></span>
      </b-col>
      <b-col md="2" class="tabtext">
        <span ><b>State</b></span>
      </b-col>
      <b-col md="3" class="tabtext">
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <!-- <ul id="example-1">
          <li v-for="zip in zip.current_territory_zips" :key="zip.ZipCode">{{ zip.ZipCode }}</li>
        </ul>-->
        <TerritoryZipRow
            v-for="zip in current_territory.Zips"
            :key="zip.ZipCode"
            :territory_object="current_territory"
            :zip_object="zip"
          />
      </b-col>
    </b-row>
     <b-row class="mt-2">
      <b-col lg="12">
        <!-- <ul id="example-1">
          <li v-for="zip in zip.current_territory_zips" :key="zip.ZipCode">{{ zip.ZipCode }}</li>
        </ul>-->
        <TerritoryZipRow
          :territory_object="current_territory"
          :zip_object= "blank_zip"
          v-bind:is_new="true"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import TerritoryZipRow from "@/components/CustomRowComponents/TerritoryZipRow.vue";

export default {
  name: "TerritoryZipEditor",
  props: {
    territory_object: { type: Object },
  },
  components: { TerritoryZipRow },
  data() {
    return {
      current_territory: this.territory_object, 
      blank_zip: {ZipCode: ''}
    };
  },
  computed: {
    ...mapState(["seminar", "territory", "zip", "n_user"]),
  },
  methods: {
   
  },
  created() {
    
  },
  watch: {
     current_territory: function (newValue, oldValue) {
    },
  },
};
</script>

<style lang="scss" scoped>
</style>